import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { plusIcon, TextInput } from "../../Components";
import { uploadService } from "../../Services";
import {
  decodeFromBase64,
  parseToJson,
} from "../../Components/Constants/AppConstant";

export default function BrandProfileCompany({
  form,
  setInput,
  updateForm,
  saveChanges,
  setToastList,
  toastList,
  refCompany,
}) {
  const [error, setError] = useState(false);
  const fileRef = useRef(null);
  const [file, setFile] = useState(form.brand?.photo || "");
  const [isUploading, setIsUploading] = useState(false);
  const isAsset = false;
  const [fileDetail, setFileDetail] = useState({
    type: form.brand?.media_type_id || 2,
    name: form.brand?.photo_url || "",
  });

  console.log("🚀 ~ BrandProfileCompany ~ form:", form.brand?.photo_url);

  const readFile = ({ file, onLoad }) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = ({ target }) => onLoad(target.result);
      reader.readAsDataURL(file);
    }
  };

  const previewImage = () => {
    if (fileRef.current.files && fileRef.current.files[0]) {
      const fileType = fileRef.current.files[0].type;
      if (
        !fileType.startsWith("image") ||
        fileRef.current.files[0].size > 10000000
      ) {
        addToast({
          error: true,
          date: new Date(),
          msg: ".GIF, .PNG, .JPG only with a maximum file size of 10MB",
        });
        return;
      }

      readFile({
        file: fileRef.current.files[0],
        onLoad: (result) => {
          setFile(result);
          upload(fileRef.current.files[0]);
        },
      });
    }
  };

  const getFullMediaURL = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("data:")) return path;

    const baseURL =
      process.env.REACT_APP_MEDIA_BASE_URL ||
      "https://backendbeta.tamayou.com/storage/";
    return `${baseURL}${path}`;
  };

  const upload = (fileToUpload) => {
    setIsUploading(true);
    const handleProgress = (progressEvent) => {
      const percent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
    };
    uploadService
      .upload(fileToUpload, handleProgress, isAsset)
      .then((response) => {
        const res = parseToJson(decodeFromBase64(response));
        if (res.message === "success") {
          console.log("🚀 ~ upload ~ res:", res);

          const fullImagePath = getFullMediaURL(res.path);
          const fullThumbnailPath = getFullMediaURL(res.thumbail_path);

          setFile(fullImagePath);
          setFileDetail({
            type: 2,
            name: res.thumbail_path,
          });
          updateForm({
            brand: {
              ...form.brand,
              photo: fullImagePath,
              media_type_id: 2,
              photo_thumbnail: fullThumbnailPath,
            },
          });
        } else {
          addToast({
            error: true,
            date: new Date(),
            msg: res.message || "Upload failed",
          });
        }
      })
      .catch((err) => {
        setFile("");
        setFileDetail({});
        addToast({ error: true, date: new Date(), msg: err.message });
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    console.log("newToastList", newToastList);
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  useEffect(() => {
    updateForm({ mediafile: file });
  }, [file]);

  console.log(
    "🚀 ~ BrandProfileCompany ~   form.brand?.photo:",
    form.brand?.photo
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      exit={{ opacity: 0, y: 30 }}
      className="form"
    >
      <div className="form__title">
        <h3 className="big">Company</h3>
      </div>
      <button
        ref={refCompany}
        className="button secondary !border !border-gray-200 !bg-gray-50 hover:!bg-[#e9f1e7]"
        onClick={() => {
          if (isUploading) {
            addToast({
              error: true,
              date: new Date(),
              msg: "Please wait for upload to complete",
            });
            return;
          }
          saveChanges("company");
          setError(true);
        }}
        disabled={isUploading}
      >
        {isUploading ? "Uploading..." : "Save changes"}
      </button>

      <div className="form__company">
        <div className="form__company-inner">
          <div className="form__company-input">
            <TextInput
              value={form.brand.brand_name}
              type="text"
              onChange={setInput("brand", "brand_name")}
              label="Company name"
              error={error}
              errorText="Please enter Company name"
              autocomplete="brandname"
              autoFocus
              isRequired
            />
          </div>
          <div className="form__company-file">
            <h6 className="semi">
              Upload logo <span className="text-red-500">*</span>
            </h6>
            <div className="form__company-file-inner">
              {file ? (
                <>
                  <div className="form__company-preview">
                    <div className="assets__media">
                      <img
                        src={
                          file.startsWith("data:") ? file : form.brand?.photo_url
                        }
                        alt="Company logo"
                      />
                    </div>
                  </div>
                  <div className="form__company-change">
                    <button
                      className="button secondary !border !border-gray-200 !bg-gray-50 hover:!bg-[#e9f1e7]"
                      onClick={() => fileRef.current?.click()}
                      disabled={isUploading}
                    >
                      {isUploading ? "Uploading..." : "Change Image"}
                    </button>
                    <input
                      title=" "
                      type="file"
                      accept="image/jpeg,image/gif,image/png"
                      ref={fileRef}
                      onChange={previewImage}
                      style={{ display: "none" }}
                    />
                  </div>
                </>
              ) : (
                <div
                  className={`form__company-upload ${
                    error ? "error" : ""
                  }`}
                >
                  <div className="form__company-upload-icon">{plusIcon}</div>
                  <h5 className="reg">Upload media</h5>
                  <p className="sm">
                    .GIF, .PNG, .JPG only with a maximum file size of 10MB
                  </p>
                  <button
                    className="button primary"
                    onClick={() => fileRef.current?.click()}
                  >
                    Upload
                  </button>
                  <input
                    title=" "
                    type="file"
                    accept="image/jpeg,image/gif,image/png"
                    ref={fileRef}
                    onChange={previewImage}
                    style={{ display: "none" }}
                  />
                  {error && (
                    <div className="form__company-upload-error">
                      Please upload file
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
